// @ts-nocheck - to do
export function removeDuplicateObjValuesFromArray<T>(arr: T[], key: unknown) {
  if (!arr.includes(undefined)) {
    return arr.filter(
      (value: T, index: number, array: T[]) =>
        array.findIndex((element: T) => element[key] === value[key]) === index
    );
  }
}
